// 改派 营销员 电商专员 云客服
import React, {useState, useEffect, useCallback} from 'react'
import request, {METHODS} from '@/api'
import {Row, Col, ConfigProvider, Button, Form, Input, Select, Table, message} from 'antd'
import {SCommonDialog, SLowcodeList} from 'shj-components'
import zhCN from 'antd/lib/locale/zh_CN'
import {isEmpty} from 'lodash-es'
import track from '@/utils/track'
import {queryEcommerce} from '@/services/publicInformation.ts'
import {getEmployee, querySalesMan} from '@/services/customerServices.ts'
import dayjs from 'dayjs'
import UrlConfig from '@/api/UrlConfigs'
import {getUser} from "@/common/utils.ts";
import {queryEmployeePage} from "@/services/callCenter";
import {useDebounceFn} from "ahooks";
import {apiData2Table} from "@/utils/data.ts";

const {Option} = Select

function ServiceEdit1(props: any) {
  const [form] = Form.useForm();
  const {id, type, onClose, ids, buttonKey, fn, listRef} = props
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([]);
  const [cur, setCur] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchData, setSearchData] = useState<any>({name: 'userNameKeyword', input: ''})
  const [select, setSelect] = useState<Record<string, any> | undefined>()

  const fetchData = ({current, pageSize, query}) => {
    if (loading) return
    if(query.userNameKeyword){
      query.employeeFilter = {userNameKeyword: query.userNameKeyword}
      delete query.userNameKeyword
    }
    return new Promise((resolve, reject) => {
      setLoading(true);
      switch (type) {
        case '云客服':
          getEmployee({
            pageId: current,
            pageSize,
            queryEmployee: true,
            queryOrg: true,
            roleCode: 'ykf',
            ...query
          }).then((resp: any) => {
           resolve(apiData2Table(resp))
          }).finally(() => {
            setLoading(false)
          })
          break
        case '电商专员':
          queryEcommerce(id).then((resp: any) => {
            const records = resp?.list || []
            const total = resp?.count || 0
            setList(records)
            setTotal(total)
          }).finally(() => {
            setLoading(false)
          })
          break
        case '数智轻奢装营销员':
        case '营销员':
          querySalesMan({
            data: {clueIdList: ids ? ids : [id]},
            params: {current: 1, pageSize: 99999},
          }).then((resp: any) => {
            const records = resp?.list || []
            const total = resp?.count || 0
            setList(records)
            setTotal(total)
          }).finally(() => {
            setLoading(false)
          })
          break
        default:
          break
      }
    })

  }

  const onFinish = () => {
    if (!select) {
      message.error(`请选择一个${type}`)
      return
    }
    setLoading(true)
    let url = ''
    let _data: Record<string, any> = {}
    switch (type) {
      case '云客服':
        url = UrlConfig.PlusCrmWeb.AssignEmployee
        _data = {
          clueId: ids ? ids[0] : id,
          relatives: {
            name: select.userName,
            ucenterUserId: select.ucenterUserId,
            deptId: select.orgId,
            companyId: select.companyId,
            roleCode: select.roleCode,
          },
          buttonKey
        }
        break
      case '电商专员':
        url = UrlConfig.Clue.ReassignElectric
        _data = {
          ids: ids ? ids : [id],
          clueRelatives: {
            workerNumber: select.workNumber,
            name: select.workName,
            departPosCode: select.positionCode,
            departPosName: select.positionName,
            deptCode: select.deptCode,
            deptName: select.deptName,
            companyCode: select.companyCode,
            companyName: select.companyName,
          },
        }
        break
      case '数智轻奢装营销员':
        url = UrlConfig.Clue.DispatchForLuxury
        _data = {
          clueId: id,
          workerNumber: select.workNumber,
          name: select.workName,
          departPosCode: select.positionCode,
          departPosName: select.positionName,
          deptCode: select.deptCode,
          deptName: select.deptName,
          companyCode: select.companyCode,
          companyName: select.companyName,
          buttonKey: buttonKey,
        }
        break;
      case '营销员':
        if (ids) {
          url = UrlConfig.Clue.BatchDispatch
          _data = {
            clueIdList: ids,
            // ...select,
            // workerNumber: select.workNumber,
            // departPosCode: select.positionCode,
            // departPosName: select.positionName,
            buttonKey: buttonKey,
            workerNumber: select.workNumber,
            name: select.workName,
            departPosCode: select.positionCode,
            departPosName: select.positionName,
            deptCode: select.deptCode,
            deptName: select.deptName,
            companyCode: select.companyCode,
            companyName: select.companyName,
          }
        } else {
          url = UrlConfig.Clue.ClueDispatch
          _data = {
            clueId: id,
            // ...select,
            // workerNumber: select.workNumber,
            // departPosCode: select.positionCode,
            // departPosName: select.positionName,
            buttonKey: buttonKey,
            workerNumber: select.workNumber,
            name: select.workName,
            departPosCode: select.positionCode,
            departPosName: select.positionName,
            deptCode: select.deptCode,
            deptName: select.deptName,
            companyCode: select.companyCode,
            companyName: select.companyName,
          }
        }
        break
      default:
        break
    }
    request(url, {
      method: METHODS.POST,
      data: _data,
    })
        .then(() => {
          message.success('操作成功')
          listRef && listRef.current.reload()
          fn && fn()
          onClose()
        })
        .finally(() => {
          setLoading(false)
        })
  }

  const change = (v: any, name: string) => {
    const _data = {...searchData}
    if (name == 'input') {
      _data[name] = v.target.value
    } else {
      _data[name] = v
    }
    setSearchData(_data)
  }
  const search = () => {
    setCur(1)
    fetchData()
  }

  const extensions = {
    request: {fetchList: fetchData},
    rowSelection: {
      onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
        console.log(111)
        // const _list = [...tableSelect];
        // _list[index] = selectedRows[0];
        // setTableSelect(_list);
        setSelect(selectedRows[0])
      },
    }
  }

  return (
      <>
        <Row style={{marginBottom: 10}}>
          <Col span={12}>
            {`新${type}: ` +
                (select ? select.orgNamePath + '-' + select.userName : '')}
          </Col>
        </Row>
        <SLowcodeList
            searchMode='group'
            config={{
              fieldControl: false,
              rowSelectionType: 'radio',
              scroll: {y: 350},
              columns: [
                {title: '姓名', dataIndex: 'userName', width: 150, ellipsis: true},
                {title: '电话', dataIndex: 'userPhone', width: 120},
                {title: '部门', dataIndex: 'orgNamePath', width: 200, ellipsis: true},
                {title: '职位', dataIndex: 'roleName', width: 150, ellipsis: true}],
              search: [
                {name: 'userNameKeyword', label: '姓名'}
              ]
            }} {...extensions}/>

        {/*   <Table
            rowSelection={{
              type: 'radio',
              onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
                // const _list = [...tableSelect];
                // _list[index] = selectedRows[0];
                // setTableSelect(_list);
                setSelect(selectedRows[0])
              },
            }}
            scroll={{y: 350}}
            dataSource={list}
            rowKey="id"
            loading={loading}
            columns={[
              {title: '姓名', dataIndex: 'userName'},
              {title: '电话', dataIndex: 'userPhone'},
              // { title: '工号', dataIndex: 'workNumber' },
              {title: '部门', dataIndex: 'orgNamePath'},
              // { title: '部门', dataIndex: 'orgName' },
              {title: '职位', dataIndex: 'roleName'},
            ]}
            pagination={{
              current: cur,
              pageSize,
              total,
              showTotal: (total) => `${total}条`,
              onChange: (page, pageSize) => {
                setCur(page)
                setPageSize(pageSize)
                fetchData()
              }
            }}
        />*/}
        <Row>
          <Col span={24} style={{textAlign: 'right', marginTop: 10}}>
            <Button onClick={onClose} style={{margin: '0 8px'}} disabled={loading}>
              取消
            </Button>
            <Button type="primary" onClick={onFinish} disabled={loading}>
              确定
            </Button>
          </Col>
        </Row>
      </>
  )
}

export function clueServiceEdit(props: any) {
  const {id, type, ids, buttonKey, fn, listRef, onclose} = props
  if (!isEmpty(props.trackParams)) {
    track('task_page_view', {
      enter_time: dayjs().format('yyyy-MM-DD HH:mm:ss'),
      ...props.trackParams,
    })
  }
  const onClose = () => {
    if (!isEmpty(props.trackParams)) {
      track('task_page_close', {
        leave_time: dayjs().format('yyyy-MM-DD HH:mm:ss'),
        ...props.trackParams,
      })
    }
    onclose && onclose()
    dialog.destroy()
  }
  const dialog = SCommonDialog({
    title: type == '营销员' && ids ? `分配营销员` : `改派${type}`,
    width: 1000,
    content: (
        <ConfigProvider locale={zhCN}>
          <ServiceEdit1
              onClose={onClose}
              ids={ids}
              id={id}
              type={type}
              buttonKey={buttonKey}
              fn={fn}
              listRef={listRef}
          />
        </ConfigProvider>
    ),
  })

  return dialog
}
